// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".magnum-spa.80f5ec284f23f599dc86900c203a25a2faa6ffc7.js";
};